import { render, staticRenderFns } from "./WeatherNotice.vue?vue&type=template&id=b85eb6a6&scoped=true"
import script from "./WeatherNotice.vue?vue&type=script&lang=js"
export * from "./WeatherNotice.vue?vue&type=script&lang=js"
import style0 from "./WeatherNotice.vue?vue&type=style&index=0&id=b85eb6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85eb6a6",
  null
  
)

export default component.exports